(() => {
  if (window.KaisiteContactFormState) return;

  const initializedWrappers = new WeakSet();
  const STORAGE_PREFIX = 'kaisite:contact-form-state:';

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  };

  const getStorageKey = (wrapper, form) => {
    return `${STORAGE_PREFIX}${wrapper.dataset.contactFormStateKey || form.id || 'default'}`;
  };

  const readState = (storageKey) => {
    try {
      return JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
    } catch (error) {
      return {};
    }
  };

  const writeState = (storageKey, value) => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
      // Ignore storage errors so form submissions still work normally.
    }
  };

  const clearState = (storageKey) => {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Ignore storage errors so form submissions still work normally.
    }
  };

  const serializeForm = (form) => {
    const state = {};

    form.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
      if (
        field.disabled ||
        field.type === 'hidden' ||
        field.type === 'file' ||
        field.type === 'submit' ||
        field.type === 'button' ||
        field.type === 'reset'
      ) {
        return;
      }

      if (field.type === 'radio') {
        if (field.checked) {
          state[field.name] = field.value;
        }
        return;
      }

      if (field.type === 'checkbox') {
        state[field.name] = field.checked;
        return;
      }

      state[field.name] = field.value;
    });

    return state;
  };

  const applyState = (form, state) => {
    Object.entries(state).forEach(([name, value]) => {
      const selector = `[name="${escapeSelector(name)}"]`;
      const fields = Array.from(form.querySelectorAll(selector));

      if (!fields.length) return;

      const checkedField = form.querySelector(`${selector}:checked`);

      fields.forEach((field) => {
        if (field.type === 'radio') {
          if (!checkedField && String(field.value) === String(value)) {
            field.checked = true;
          }
          return;
        }

        if (field.type === 'checkbox') {
          if (!field.checked) {
            field.checked = Boolean(value);
          }
          return;
        }

        if (field.tagName === 'SELECT') {
          if (!field.value && value !== '') {
            field.value = value;
          }
          return;
        }

        if (field.value === '' && value !== '') {
          field.value = value;
        }
      });
    });
  };

  const initWrapper = (wrapper) => {
    if (initializedWrappers.has(wrapper)) return;

    const form = wrapper.querySelector('form');
    if (!form) return;

    const storageKey = getStorageKey(wrapper, form);

    if (wrapper.querySelector('[data-contact-form-success]')) {
      clearState(storageKey);
    } else {
      applyState(form, readState(storageKey));
    }

    const persistState = () => {
      writeState(storageKey, serializeForm(form));
    };

    form.addEventListener('input', persistState);
    form.addEventListener('change', persistState);
    form.addEventListener('submit', persistState);

    initializedWrappers.add(wrapper);
  };

  const initWrappers = (container = document) => {
    container.querySelectorAll('[data-contact-form-state]').forEach((wrapper) => {
      initWrapper(wrapper);
    });
  };

  window.KaisiteContactFormState = { initWrappers };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWrappers());
  } else {
    initWrappers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWrappers(event.target);
  });
})();
